import { GridColDef } from "@mui/x-data-grid";


export const nestedColumns: GridColDef[] = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1.3,
    },
    {
        field: 'name',
        headerName: 'Search Name',
        width: 300,
    },
    { field: 'searchGroup', headerName: 'Search Group', flex: 1.6 },
    { field: 'lastCompleteTime', headerName: 'Last Complete Time', width: 300, },
]